export default {
  state: {
    count: 0
  },
  mutations: {
    inc: state => state.count++,
    dec: state => state.count--,
  },
  actions: {
    inc(context) {
  context.commit('inc')
},
dec(context) {
  context.commit('dec')
}
}

}



// WEBPACK FOOTER //
// ./src/store/head.js